var $body = $(document.body);
var mobileSize = 992;
var currentId = 0;

function getOffsetBottom() {
    var feedbackHeight = $('.feedback').outerHeight() ? $('.feedback').outerHeight() : 0;
    var footerHeight = $('#footer').outerHeight() ? $('#footer').outerHeight() : 0;
    var navHeight = feedbackHeight + footerHeight;
    return navHeight;
}

function getOffsetTop() {
    var offset = $('.plan__page').offset().top;
    return offset - 60;
}


function checkMenu() {

    var menu = $(".plan__navigation ul"),
        menuItems = menu.find("a, ul a"),
        scrollItems = menuItems.map(function () {
            var item = $($(this).attr("href"));
            if (item.length) { return item; }
        });

    var fromTop = $(this).scrollTop();
    var cur = scrollItems.map(function () {
        if ($(this).offset().top + 15 > fromTop)
            return this;
    });

    cur = cur[0];

    var id = cur && cur.length ? cur[0].id : "";

    if (currentId !== id) {

        menuItems.parent().removeClass("current");
        menuItems.parent().parent().parent().removeClass("current");

        menuItems.filter("[href='#" + id + "']").parent().addClass("current");
        menuItems.filter("[href='#" + id + "']").parent().parent().parent().addClass("current");

        if (history.replaceState) {
            history.replaceState(null, null, "#" + id);
        }

        currentId = id;
    }
}
$(window).scroll(function () {
    checkMenu();
});



$(function() {
    $(".content-menu").click(function() {

        $(".content-menu").toggleClass("content-menu--open");
        $(".plan__content").toggleClass("plan__content--hide");
        $(".plan__header").toggleClass("plan__header--hide");
        $(".plan__navigation").toggleClass("plan__navigation--hide");


        $('html, body').animate({
            scrollTop:0
        }, 1000);

        $("#sidebar a").off('click');

        $("#sidebar.mobile a").click(function () {
            $(".content-menu").toggleClass("content-menu--open");
            $(".plan__content").toggleClass("plan__content--hide");
            $(".plan__header").toggleClass("plan__header--hide");
            $(".plan__navigation").toggleClass("plan__navigation--hide");
        });

        return false;
    });

    $(".element-sub").on("click",
        function () {
            $(this).parent().toggleClass("current");
        });

    $(window).on('resize',
        function () {

            if ($(window).width() < mobileSize) {
                $('#sidebar').addClass('mobile');
            } else {

                $('#sidebar').removeClass('mobile');
            }
        }
    );

    if ($(window).width() < mobileSize) {
        $('#sidebar').addClass('mobile');
    } else {

        $('#sidebar').removeClass('mobile');
    }

});

$(".search-page1 .toggle-filter1").click(function () {
    $(".toggle-filter-container").toggleClass("open");
    $(".search-filter").toggle();
});
